import type { IconSymbolName } from "@/components/ui/IconSymbol";

// Entity icons using MaterialIcons (MI) or MaterialCommunityIcons (MCI) names
// IconSymbol will automatically pick the right library based on the name
export const ENTITY_ICONS = {
  // Navigation entities
  dashboard: "dashboard", // MI
  projects: "handyman", // MI
  shifts: "calendar-month", // MI
  chat: "message", // MI
  courses: "school", // MI
  users: "person", // MI
  contacts: "contacts", // MCI
  time_cards: "punch-clock", // MI
  expenses: "receipt", // MI
  clients: "business", // MI
  settings: "cog", // MCI
  crew: "smartphone", // MI

  // External/billing
  invoices: "file-document", // MCI
  estimates: "calculator-variant", // MCI
  billing_items: "cash-multiple", // MCI

  // Additional entities
  incidents: "warning", // MI
  investigations: "search", // MI
  payroll: "payment", // MI
  applications: "person-add", // MI

  // Status/actions
  home: "home", // MCI
  accepted: "checkbox-marked-circle", // MCI
  preferences: "cog", // MCI
  about: "info", // MI
  send: "send", // MCI
  completed: "checkbox-marked-circle", // MCI
  pending: "schedule", // MI

  // Testing/dev
  testing: "science", // MI
  ui: "palette-outline", // MCI
} as const satisfies Record<string, IconSymbolName>;

export type EntityIconKey = keyof typeof ENTITY_ICONS;
export type EntityIconName = (typeof ENTITY_ICONS)[EntityIconKey];

export function getEntityIcon(key: EntityIconKey): EntityIconName {
  return ENTITY_ICONS[key];
}
